// src/services/aadhaarService.js
export default  (axios) => ({
    generateOtp(idNumber) {
      return axios.post('/api/v1/aadhaar-v2/generate-otp', { id_number: idNumber });
    },
  
    submitOtp(idNumber, otp) {
      return axios.post('/api/v1/aadhaar-v2/submit-otp', { client_id: idNumber, otp:otp });
    },
    nameMatch(aadharNumber,name2,name_type='person'){
      return axios.post('/api/v1/utils/name-matching/',{name_1:aadharNumber,name_2:name2,name_type});
    }
  });
  